module.exports = __webpack_public_path__ + "img/official-verification-icon1.e944b87b.svg";